import * as THREE from 'three'
import { Location } from './Location'
import { RAD2DEG } from 'three/src/math/MathUtils.js'
import { normalToDirection } from './normalToDirection'
import { Directions } from './chunks'

const v1 = new THREE.Vector3()

export class PlacerContext {
  constructor() {
    this.location = new Location()
    this.hit = {
      direction: null,
    }
    this.placer = {
      yaw: 0,
      pitch: 0,
      direction: null,
    }
  }

  set(loc, hitNormal, placerObj) {
    this.location.copy(loc)
    this.hit.direction = normalToDirection(hitNormal)

    const dir = v1
    placerObj.getWorldDirection(dir)

    // Game yaw: 0 = +Z? or 0 = -Z? pick one.
    // Here: 0° = +Z (call that "south"), 90° = +X ("east"), etc.
    // If you want 0° = -Z ("north"), just add 180° afterwards.

    // yaw 0° = north (-Z), 90° = east (+X), clockwise
    let yawRad = Math.atan2(dir.x, -dir.z)
    let yawDeg = yawRad * RAD2DEG
    // normalize to 0..360
    // yaw: north(0) east(90) south(180) west(270)
    this.placer.yaw = ((yawDeg % 360) + 360) % 360

    // Pitch: angle above horizontal
    let pitchRad = Math.asin(dir.y)
    let pitchDeg = pitchRad * RAD2DEG // -90..90
    // pitch: -90 (down) to 90 (up)
    this.placer.pitch = pitchDeg

    this.placer.direction = normalToDirection(dir)
  }

  serialize() {
    return {
      location: this.location.world.toArray(),
      hit: {
        direction: this.hit.direction.name,
      },
      placer: {
        yaw: this.placer.yaw,
        pitch: this.placer.pitch,
        direction: this.placer.direction.name,
      },
    }
  }

  deserialize(data) {
    this.location.world.fromArray(data.location)
    this.hit.direction = Directions[data.hit.direction]
    this.placer.yaw = data.placer.yaw
    this.placer.pitch = data.placer.pitch
    this.placer.direction = Directions[data.placer.direction]
    return this
  }
}
